import templates from '~/src/services/blocks/templates';
import { ICurrentProject } from '~/src/services/projects';
import cloneDeep from 'lodash/cloneDeep';
import pickBy from 'lodash/pickBy';
import { flattenTreeView } from '~/src/services/blocks/index';

export const addToStore = (project: ICurrentProject, blockTitle: string, parentId?: string): ICurrentProject => {
    const { body, blocksCount } = project;

    const newBlock = cloneDeep(templates[blockTitle]);

    newBlock.title = `${newBlock.title}[${blocksCount}]`;
    const flattenBlock = flattenTreeView(
        [newBlock],
        parentId,
        parentId,
        parentId ? parentId.replace(/\[\d+\]/, '') : undefined
    );

    return {
        ...project,
        blocksCount: +blocksCount + 1,
        body: {
            ...body,
            ...flattenBlock,
        },
    };
};

export const removeFromStore = (project: ICurrentProject, id: string): ICurrentProject => {
    const { body } = project;
    const newBody = pickBy(
        { ...body },
        (item, key) =>
            !key.startsWith(id)
    );

    return {
        ...project,
        body: newBody,
    };
};
